/** @format */

import styled from 'styled-components';

export const Wrapper = styled.div<{ isPopup?: boolean }>`
  align-self: ${({ isPopup }) => (isPopup ? 'flex-end' : 'auto')};
  display: ${({ isPopup }) => (isPopup ? 'flex' : 'block')};
  align-items: ${({ isPopup }) => (isPopup ? 'center' : 'normal')};
`;

export const NumbersWrapper = styled.div`
  display: flex;
  align-items: baseline;
  align-self: end;
  gap: 0.5rem;
`;

export const PromoDateWrapper = styled.div`
  color: var(--gray-500);

  span:first-child {
    text-transform: capitalize;
  }

  font-family: ${({ theme }) => theme.font.body};
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 300;
  line-height: 1.25rem;

  @media screen and (max-width: 375px) {
    max-width: 125px;
  }
`;

export const FormattedPrice = styled.span`
  color: var(--gray-900);
  font-family: ${({ theme }) => theme.font.body};
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 500;
  line-height: 1.875rem;
`;

export const Month = styled.span`
  color: var(--gray-900);

  font-family: ${({ theme }) => theme.font.body};
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 300;
  line-height: 1.25rem;
`;

export const PromoBasePercetagePrice = styled.div`
  display: flex;
  gap: 0.25rem;
`;

export const BasePrice = styled.span`
  color: var(--Error-600, #d92d20);
  font-family: ${({ theme }) => theme.font.body};
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 500;
  line-height: 1.25rem;
  text-decoration: line-through;
`;
export const DiscountPercentage = styled.div`
  display: flex;
  color: var(--Error-600, #d92d20);
  font-family: ${({ theme }) => theme.font.body};
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 500;
  line-height: 1.25rem;
`;
